import React from 'react';
import { navigate } from 'gatsby';
import * as style from './fellowshipHeader.module.scss';
import translations from '../../utils/translations';
import { formatAuthorsJsx, formatArticleDate } from '../../utils/articleFormatters';
import VideoEmbed from '../basic/videoEmbed';


const FellowshipHeader = (props) => {
	const {
		title,
		authors,
		hideDate,
		createdDate,
		src,
		credit,
		featuredVideo,
		youtubeVideo
	} = props;

	const _authors = formatAuthorsJsx(authors, { bold: true });

	return (
		<div className={style.feature}>
			<div className={style.container}>
				<div className={style.wrap}>
					{/* */}
					<div
						onClick={() => {
							navigate('/projects')
						}}
						className={`backLink`}
					>
						<a
							className={`icon-circle-orange fa-arrow-left backIcon`}
							rel="noopener"
						>
							<span>TOP</span>
						</a>
						<a className={`backText`}>
							PROJECTS
						</a>
					</div>
					{/* */}
					<h3 className={style.label}>Fellowship Stories</h3>
					<div className={style.title}>{title}</div>
					<div className={style.authors}><strong>{translations.t('Produced by')}</strong> {_authors}</div>
					{hideDate === false
						&& <span className={style.createdDate}>
							{formatArticleDate(createdDate)}
						</span>
					}
				</div>
			</div>
			<div className={style.imageWrap}>
				{featuredVideo ? (
					<VideoEmbed
						heading={''}
						imgSrc={featuredVideo?.image?.sizes?.standard_md ?? ''}
						videoUrl={featuredVideo.url}
						videoId={featuredVideo.id}
						isFeatured
						small
					/>
				) : youtubeVideo?.url ? (
					<div className={style.youtubeWrap}>
						<iframe
							src={youtubeVideo.url
								.replace(/watch\?v=(.+?)/, 'embed/$1')
								.replace(/(?:https|http):\/\/(.*?)youtu\.be/, 'https://www.youtube-nocookie.com/embed')
								.replace('www.youtube.com/embed', 'www.youtube-nocookie.com/embed')
								+ '?autoplay=0&controls=1&rel=0&modestbranding=1'}
							title="YouTube video player"
							referrerPolicy="strict-origin-when-cross-origin"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						></iframe>
						{youtubeVideo.credit && <div className={style.credit}>{youtubeVideo.credit}</div>}
					</div>
				) : (
					<>
						<img className={style.featuredImage} src={src} alt={title} />
						<div className={style.credit}>{credit}</div>
					</>
				)}
			</div>
		</div>
	)
}

export default FellowshipHeader;